module.exports = __webpack_public_path__ + "img/exterior.ee414c09.jpg";